export default {
  getUser({ user }) {
    return user
  },

  getEmpresaPrincipal({ empresaPrincipal }) {
    return empresaPrincipal
  },

  getGrupoPrincipal({ grupoPrincipal }) {
    return grupoPrincipal
  },

  getPrefix({ prefix }) {
    return prefix
  },

  getPapel({ papel }) {
    return papel
  },

  isLogged(state) {
    return (
      state.user && state.user.id && state.user.empresaPrincipal &&
      state.user.grupoPrincipal && state.user.prefix
    ) ? true : false
  }
}
